import React from 'react';

function Error() {
    return (
        <div>
            <section id="about-index">
                <div class="container">
                    <div class="section-heading text-center"><br /><br />
                        <h1>404</h1>
                        <h2>Page not found</h2>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Error;